import React, { useEffect, useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMenu, FiX } = FiIcons;

const links = [
  ['Books', '#books'],
  ['Characters', '#characters'],
  ['World', '#world'],
  ['Author', '#author']
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className={`site-header ${scrolled ? 'scrolled' : ''}`}>
      <a className="brand" href="#top" aria-label="E.A. Kross home">
        E.A. <span>KROSS</span>
      </a>
      <nav className={open ? 'nav-open' : ''} aria-label="Primary navigation">
        {links.map(([label, href]) => (
          <a key={label} href={href} onClick={() => setOpen(false)}>{label}</a>
        ))}
        <a className="nav-cta" href="#books" onClick={() => setOpen(false)}>Enter the world</a>
      </nav>
      <button className="menu-button" onClick={() => setOpen(!open)} aria-label="Toggle menu">
        <SafeIcon icon={open ? FiX : FiMenu} />
      </button>
    </header>
  );
}
